module.exports = __webpack_public_path__ + "images/grant-summary-graphic.svg";